import { useAtom } from "jotai";
import { htmlDataAtom, htmlDataTypeAtom } from "./atoms";

export function useHTMLData() {
  const [type, setType] = useAtom(htmlDataTypeAtom);
  const [{ data, error, isLoading }] = useAtom(htmlDataAtom);
  return {
    type,
    setType,
    data,
    error,
    isLoading,
  };
}
